import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { forkJoin } from 'rxjs';
import { BranchHttpService } from '../http/branch-http.service';
import { ComplainHttpService } from '../http/complain-http.service';
import { LocationHttpService } from '../http/location-http.service';
import { AccountService } from '../services/account.service';

@Injectable({
    providedIn: 'root',
})
export class ComplainListHttpResolverService implements Resolve<any> {
    constructor(private complainHttpService: ComplainHttpService, private accountService: AccountService) {}
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        return this.complainHttpService.getAllComplains(this.accountService.currentUser.branchId);
    }
}

@Injectable({
    providedIn: 'root',
})
export class ComplainEditHttpResolverService implements Resolve<any> {
    constructor(private branchHttpService: BranchHttpService, private complainHttpService: ComplainHttpService) {}
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        let getAllBranches = this.branchHttpService.getAllBranches();
        let getComplainById = this.complainHttpService.getComplainById(route.params.id);
        return forkJoin([getAllBranches, getComplainById]);
    }
}

@Injectable({
    providedIn: 'root',
})
export class ComplainNewHttpResolverService implements Resolve<any> {
    constructor(private branchHttpService: BranchHttpService) {}
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        return this.branchHttpService.getAllBranches();
    }
}
